import {
  Box,
  BoxProps,
  Button,
  Center,
  Flex,
  FlexProps,
  Heading,
  Icon,
  Text,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { HiOutlineClock } from 'react-icons/hi';
import { useParams } from 'react-router-dom';
import { useEventHistory } from '../../hooks';

type ContainerProps = FlexProps & {
  children: ReactNode;
};

const Container = ({ children, ...props }: ContainerProps) => (
  <Flex
    as="section"
    direction="column"
    align="center"
    w="100%"
    maxW="sm"
    {...props}>
    {children}
  </Flex>
);

type CardProps = BoxProps & {
  children: ReactNode;
};
const Card = ({ children, ...props }: CardProps) => (
  <Box
    boxShadow="container"
    borderRadius="xl"
    bg="white"
    p="6"
    w="100%"
    {...props}>
    {children}
  </Box>
);

export const CheckoutPixRejected = () => {
  const eventHistory = useEventHistory();
  const { eventID } = useParams();

  return (
    <Center
      flexDirection="column"
      position="fixed"
      top={0}
      bottom={0}
      left={0}
      right={0}
      bg="#f44336"
      p="5">
      <Container maxW="xl">
        <Icon
          as={HiOutlineClock}
          boxSize="20"
          color="white"
          mb="2"
          alignSelf="center"
        />
        <Heading
          fontSize="4xl"
          color="white"
          textAlign="center"
          as="h1"
          m="0"
          mb="10">
          Esgotou tempo para pagar o Pix
        </Heading>
        <Card>
          <Text color="black" mb="6">
            O tempo máximo para pagamento do Pix era de 7 minutos. Os ingressos
            reservados foram liberados para compra pelos demais compradores.
            Tente obter os ingressos novamente clicando no botão abaixo.
          </Text>
          <Button
            onClick={() => {
              eventHistory.replace(`/event/${eventID}`);
            }}
            w="full"
            colorScheme="blue"
            rounded="full">
            Voltar para o evento
          </Button>
        </Card>
      </Container>
    </Center>
  );
};
